import { useEffect } from 'react';
import { SEO, META_PIXEL_ID } from '../data/config';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}

/**
 * Sets the document title and meta description, and loads the Meta Pixel
 * base code plus the initial PageView event.
 */
export function MetaPixel() {
  useEffect(() => {
    document.title = SEO.title;
    let description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.name = 'description';
      document.head.appendChild(description);
    }
    description.content = SEO.description;
  }, []);
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) {
        fbq!.callMethod.apply(fbq, args);
      } else {
        fbq!.queue!.push(args);
      }
    } as NonNullable<Window['fbq']>;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const pixelImage = document.createElement('img');
    pixelImage.height = 1;
    pixelImage.width = 1;
    pixelImage.style.display = 'none';
    pixelImage.alt = '';
    pixelImage.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(pixelImage);
    document.head.appendChild(noscript);
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}